export enum SecretCodeState {
  LOADING = "loading", // API Fetching State
  PENDING = "pending", // Giver is pending to share the code
  CLAIMABLE = "claimable", // Giver can claim the bonus
  EXPIRED = "expired", // Giver's bonus expired
  REDEEMABLE = "redeemable", // Taker can redeem the code
  LOCKED = "locked", // Taker can see code but needs to fulfill requirements (e.g., deposit)
  REDEEMED = "redeemed", // Taker redeemed the code
  UNAVAILABLE = "unavailable", // Taker is ineligible
}

export enum SecretCodeSubpage {
  GIVER = "giver",
  TAKER = "taker",
}
